import {Base} from "@/api/Base"

export class CommissionRateEdit extends Base {
    path = "commissionRate/edit"
}